import { $generateHtmlFromNodes } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

interface MentionsPluginProps {
  setValue: (key: string, mentioned_account_ids: number[] | string) => void;
}

export function HTMLPlugin({ setValue }: MentionsPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerUpdateListener(({ editorState }) => {
      editorState.read(
        () => {
          const htmlString = $generateHtmlFromNodes(editor, null);
          setValue("html_content", htmlString);
        },
        { editor }
      );
    });
  }, [editor, setValue]);
  return <></>;
}
